import Model from './BaseModel';
import Race from './Race';

export default class Result extends Model {
	resourceName() {
		return 'result';
	}

	fields() {
		return ['placings', 'exotics'];
	}

	relationships() {
		return {
			race: new Race()
		};
	}

	saveManual(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}
}
